export default {"src":"/_next/static/media/example.4bd01845.gif","height":400,"width":711,"blurWidth":0,"blurHeight":0};